import { SearchContainer, JobsContainer } from "../../Components"

function AllJobs() {
  return (
    <>
      <SearchContainer />
      <JobsContainer />
    </>
  )
}

export default AllJobs